import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesWarehouses } from "../../constants";

export const requestDeleteWarehouse = async (
  warehouseId: string,
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesWarehouses.Warehouses, warehouseId),
  );
};
